import styled from 'styled-components'

export const StyledTableContainer = styled.div`
  & tr {
    height: 55px;
  }

  & .medication_expired {
    height: auto;
  }

  & .medication_expired > td {
    padding-top: 0;
  }
`

export const StyledMedicationAvatar = styled.div`
  height: 100%;
  width: 100%;
`
